module.exports = __webpack_public_path__ + "img/MapThumb_SwampPass.a3ecf873.webp";